//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../GeometricUtilities/GeometricUtilities.BooleanOperation.js";
import "../GeometricUtilities/GeometricUtilities.MultiDraft.js";
import "../GeometricUtilities/GeometricUtilities.FeatureOptions.js";
import "../GeometricUtilities/GeometricUtilities.Limits.js";
import "../GeometricUtilities/GeometricUtilities.FeatureOffset.js";
import "../GeometricUtilities/GeometricUtilities.SmartVolumeProfileBuilder.js";
import "../no/GeometricUtilities.js";
let d=[[[0,"AngularTolerance",1,0],[1,"BooleanOperation",0,"GeometricUtilities.BooleanOperation",0],[0,"ChainingTolerance",1,0],[0,"Direction",1,"Direction",0],[0,"DistanceTolerance",1,0],[1,"Draft",0,"GeometricUtilities.MultiDraft",0],[1,"FeatureOptions",0,"GeometricUtilities.FeatureOptions",0],[1,"Limits",0,"GeometricUtilities.Limits",0],[1,"Offset",0,"GeometricUtilities.FeatureOffset",0],[0,"PlanarTolerance",1,0],[0,"Section",1,"Section",0],[1,"SmartVolumeProfile",0,"GeometricUtilities.SmartVolumeProfileBuilder",0],[1,"SmartVolumeProfile1",0,"GeometricUtilities.SmartVolumeProfileBuilder",0]],[[["distance_tolerance","chaining_tolerance","planar_tolerance","angular_tolerance"],"SetToleranceValues",{},4,0],[["allow_self_intersecting_section"],"AllowSelfIntersectingSection",{},1,0]],[]];
SPLM.Features.ExtrudeBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ExtrudeBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.ExtrudeLimitDataLimitType = Object.freeze({
    "Distance" : "Distance", "UntilNext" : "UntilNext", "UntilSelected" : "UntilSelected", "UntilSelectedExtendFace" : "UntilSelectedExtendFace", "ThroughAll" : "ThroughAll"});

SPLM.ExtrudeOffsetDataOffsetType = Object.freeze({
    "None" : "None", "NormalOffset" : "NormalOffset", "SymmetricOffset" : "SymmetricOffset", "SingleOffset" : "SingleOffset"});

SPLM.ExtrudeTaperDataTaperType = Object.freeze({
    "None" : "None", "SimpleFromStart" : "SimpleFromStart", "SimpleFromProfile" : "SimpleFromProfile", "Symmetric" : "Symmetric", "MatchedEnds" : "MatchedEnds", "Asymmetric" : "Asymmetric"});

export default SPLM;